import { User } from "@/@types/sintegrada/User";
import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { getProfessionals } from "@/services/sintegrada/professional/getProfessionals";

import { SelectComponent, SelectComponentProps } from "@/components/SelectComponent";

type Props = SelectComponentProps & {
	cbos?: string[];
};

export const defaultProfessional = {
	label: "Todos os Profissionais",
	value: {} as User,
};

export function ProfessionalSelect({ cbos, ...rest }: Props) {
	const { uf, ibgeCode, cnes } = useCurrentAccount();

	async function loadOptions(search: string) {
		const data = await getProfessionals({
			uf,
			ibgeCode,
			cnes,
			cbos,
		});

		const professionalOptions = data.map((professional) => ({
			label: professional.name,
			value: professional,
		}));

		const options = [defaultProfessional, ...professionalOptions];

		return options.filter((option) =>
			option.label.toLowerCase().includes(search.toLowerCase())
		);
	}

	return (
		<SelectComponent
			isAsync
			defaultOptions
			inputId="professional"
			placeholder="Selecione..."
			loadOptions={loadOptions}
			{...rest}
		/>
	);
}
